import React, { useState, useEffect } from "react";
import { getStorySlug } from "../../../helpers/utils";
import { BQLink } from "../../atoms/bqlink";
import NewsCardImageComponent from "../../pages/markets/component/newsCardimage";
import PropTypes from "prop-types";
import EmptyState from "../empty-state";
import { FourStarIcon } from "../../atoms/material-icons";

import "./markets-news.m.css";
import { isStoryExclusive } from "../../../helpers/story-helpers";

const MarketsNews = ({ newsData }) => {
  const requiredMarketsNews = newsData?.items?.slice(0, 5);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [Marketnews, setMarketNews] = useState();

  useEffect(() => {
    const getMarketNews = async () => {
      setIsLoading(true);
      const response = await fetch("/api/v1/collections/markets");
      const data = await response;
      const dataInJson = await data.json();
      setMarketNews(dataInJson);
      setIsLoading(false);
    };
    getMarketNews();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 150);
    return () => clearTimeout(timer);
  }, []);

  const showMoreNewsHandler = () => {
    const element = document.getElementById("more-from-markets");

    if (element) {
      const scrollOffset = 150;
      const scrollPosition =
        element.getBoundingClientRect().top + window.scrollY - scrollOffset;
      window.scrollTo({ top: scrollPosition, behavior: "smooth" });
    }
  };

  return requiredMarketsNews && requiredMarketsNews?.length > 0 ? (
    <div styleName="markets-news-container">
      {requiredMarketsNews?.slice(0, 1).map((news, index) => (
        <BQLink
          story={news?.story}
          href={getStorySlug(news?.story)}
          key={index}
        >
          <NewsCardImageComponent
            story={news?.story}
            imageType="image6x4"
            aspectRatio={[6, 4]}
            showHeadline
            isLazy={false}
            isExclusive={isStoryExclusive(news?.story)}
          />
        </BQLink>
      ))}
      <div styleName="news-container">
        {requiredMarketsNews?.slice(1, 5).map((news, index) => (
          <p styleName="news-item" key={index}>
            <BQLink story={news?.story} href={getStorySlug(news?.story)}>
              {news?.story?.alternative?.home?.default?.headline
                ? news?.story?.alternative?.home?.default?.headline
                : news?.story?.headline}
              {isStoryExclusive(news?.story) && (
                <span className="exclusive-icon">
                  <FourStarIcon color="#CE9445" size="14px" />
                </span>
              )}
            </BQLink>
          </p>
        ))}
        <button styleName="market-news-btn" onClick={showMoreNewsHandler}>
          Show All Market News
        </button>
      </div>
    </div>
  ) : (
    <div styleName="no-data-container-ext">
      {initialLoading ? (
        <div styleName="loading-container"></div>
      ) : (
        <div styleName="no-data-container-int">
          <EmptyState />
        </div>
      )}
    </div>
  );
};

MarketsNews.propTypes = {
  newsData: PropTypes.object,
  loadingStatus: PropTypes.bool,
};

export default MarketsNews;
